<id-header-inera-admin [brandtext]="'IdP'"></id-header-inera-admin>
<div class="loggedout-container">
  <id-card [focuscard]="true">
    <h2 class="ids-heading-s ids-mb-2">Utloggad</h2>
    Du har blivit utloggad.
  </id-card>
</div>
<id-footer-inera-admin [headline]="'IdP'">
  <p slot="sub-footer-right">
    Legitimeringstjänsten drivs av
    <id-link [small]="true" [underlined]="true" [colorpreset]="3">
      <a href="#">
        <span>
          Inera AB
          <span class="ids-icon-external-link-small ids-icon--text-end" aria-hidden="true"></span>
        </span>
      </a>
    </id-link>
    på uppdrag av Sveriges regioner
  </p>
  <p slot="sub-footer-mobile">
    Tjänsten drivs av
    <id-link endicon="external-link-small">
      <a href="https://www.inera.se">Inera AB</a>
    </id-link>
    på uppdrag av Sveriges regioner.
  </p>
</id-footer-inera-admin>
